export const ThemeMap = {
  dark: {
    primaryBackground: "#1F1F1E", // darkest bg
    secondaryBackground: "#343432", // second darkest bg
    tertiaryBackground: "#42423e", // for cards/boxes
    primaryText: "#ffffff",
    secondaryText: "#b4b4b1",
  },
  light: {
    primaryBackground: "#F7F9FC",
    secondaryBackground: "#F5F5F5",
    tertiaryBackground: "#FFFFFF",
    primaryText: "#000000",
    secondaryText: "#4d4d4d",
  },
};
